function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import Button from '@engine/components/presentational/base/button';
import { EmailConfiguration } from '@engine/lib/utility/email-variables';
import EmailConfigurationFormFields from '@engine/components/containers/email-configurations/form-fields';
import EmailTemplatesContainer from '@engine/components/presentational/email-templates/container';
import Error from '@engine/components/presentational/base/error';
import Loader from '@engine/components/presentational/base/loader';
import Panel from '@engine/components/presentational/base/panel';
import React from 'react';
import SectionHeading from '@engine/components/presentational/base/section-heading';
import { connect } from 'react-redux';
import { save } from '@engine/actions/creators/email/form';
import { updateConfigurations } from '@engine/actions/creators/email/entity';

var EmailConfigurationForm = /*#__PURE__*/function (_React$Component) {
  _inherits(EmailConfigurationForm, _React$Component);

  var _super = _createSuper(EmailConfigurationForm);

  function EmailConfigurationForm() {
    _classCallCheck(this, EmailConfigurationForm);

    return _super.apply(this, arguments);
  }

  _createClass(EmailConfigurationForm, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(React.Fragment, null, React.createElement(Panel.Container, null, React.createElement(Panel.Body, null, React.createElement(SectionHeading, {
        heading: this.sectionHeading
      }), this.props.hasErrors && React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-lg-12 col-md-12 col-sm-12 row"
      }, React.createElement("div", {
        className: "col-lg-6 col-md-6 col-sm-6"
      }, React.createElement(Error, null, this.props.flashMessage)))), React.createElement(EmailConfigurationFormFields, {
        isTypeEditable: this.props.isNew,
        emailConfiguration: this.props.emailConfiguration,
        emailConfigurationTypes: this.props.emailConfigurationTypes
      })), React.createElement(Panel.Footer, null, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-lg-4 col-lg-offset-4 col-sm-4 col-sm-offset-4"
      }, this.props.isSubmitting && React.createElement(Loader, {
        position: "horizontal-center",
        color: "refined-blue"
      }), !this.props.isSubmitting && !this.props.isSubmitted && React.createElement(Button, {
        className: "btn btn-success btn-block",
        onClick: function onClick() {
          return _this.props.save({
            url: _this.props.baseUrl,
            entity: 'configuration',
            callbackOnSuccess: function callbackOnSuccess(data) {
              return _this.props.updateConfigurations([data.email_configuration]);
            },
            method: _this.requestMethod
          });
        }
      }, I18n.t('actions.default.save')), this.props.isSubmitted && !this.props.hasErrors && !this.props.isSubmitting && React.createElement(React.Fragment, null, React.createElement(Loader, {
        position: "horizontal-center",
        color: "refined-green",
        icon: "ok"
      }), this.redirect()))))), !this.cannotManageEmailTemplates(this.props.emailConfiguration) && React.createElement(EmailTemplatesContainer, {
        emailTemplateIds: this.props.emailConfiguration.emailTemplates,
        baseUrl: this.props.baseUrl,
        configurationType: this.props.emailConfiguration.configuration_type
      }));
    }
  }, {
    key: "cannotManageEmailTemplates",
    value: function cannotManageEmailTemplates(configuration) {
      return this.props.isNew || EmailConfiguration.WITH_DEFAULT_TEMPLATES.includes(configuration.configuration_type);
    }
  }, {
    key: "redirect",
    value: function redirect() {
      var url = this.props.isNew ? this.props.baseUrl : this.props.baseUrl.substring(0, this.props.baseUrl.lastIndexOf('/'));
      window.location.replace(url);
    }
  }, {
    key: "sectionHeading",
    get: function get() {
      var actionKey = this.props.isNew ? 'configure_new' : 'edit';
      return I18n.t("actions.object.".concat(actionKey), {
        obj: I18n.t('object.names.email_configuration')
      });
    }
  }, {
    key: "requestMethod",
    get: function get() {
      return this.props.isNew ? 'POST' : 'PUT';
    }
  }]);

  return EmailConfigurationForm;
}(React.Component);

EmailConfigurationForm.defaultProps = {
  isNew: false
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    flashMessage: state.configurationForm.flashMessage,
    hasErrors: state.configurationForm.hasErrors,
    isSubmitted: state.configurationForm.isSubmitted,
    isSubmitting: state.configurationForm.isSubmitting,
    emailConfiguration: Object.values(state.entities.configurations).filter(function (config) {
      return config.id === Number(ownProps.emailConfigurationId);
    })[0]
  };
};

export default connect(mapStateToProps, {
  save: save,
  updateConfigurations: updateConfigurations
})(EmailConfigurationForm);